import {
  Box,
  Text,
  Flex,
  FlexProps,
} from '@chakra-ui/react';
import { Image } from '@/components/Image';
import { PcDisplayBlock } from '@/components/ResponsiveBlock/PcDisplayBlock';
import { SpDisplayBlock } from '@/components/ResponsiveBlock/SpDisplayBlock';
import { ShopForRerakuBlogQuery } from '@/graphql/generated/graphql';
import { dayjs } from '@/utils/dayjs';
import { toText } from '@/utils/html';
import { getThumbnailUrl } from '@/utils/thumbnailUrl';

type BlogListItemProps = {
  blog: NonNullable<ShopForRerakuBlogQuery['shop']>['rerakuBlogs']['items'][number];
} & FlexProps;

export const BlogListItem = ({
  blog,
  ...rest
}: BlogListItemProps) => {
  const {
    title,
    content,
    publishedStartAt,
    eyeCatchingImage,
  } = blog;
  const image = getThumbnailUrl(eyeCatchingImage, content, 'src', 'house');
  return (
    <Flex
      as={'h2'}
      my={{ base: 3, md: 7 }}
      {...rest}
    >
      <Box
        flex={1}
      >
        <Box
          position={'relative'}
          height={{ base: '100px', lg: '120px' }}
          width={{ base: '100px', lg: '120px' }}
          mx={'auto'}
        >
          <Image
            src={image}
            alt={title ?? ''}
            fill
            style={{ objectFit: 'contain' }}
            unoptimized={true}
          />
        </Box>
      </Box>
      <Box
        display={'grid'}
        flex={5}
      >
        <Flex
          alignItems={'flex-start'}
        >
          <PcDisplayBlock>
            <Box>
              <Box
                px={5}
                py={3}
              >
                <Text
                  textStyle={'h6'}
                >
                  {dayjs(publishedStartAt).format('YYYY')}
                </Text>
                <Text
                  textStyle={'h3'}
                  fontWeight={'bold'}
                >
                  {dayjs(publishedStartAt).format('MM.DD')}
                </Text>
                <Text
                  textStyle={'h6'}
                >
                  {dayjs(publishedStartAt).format('HH:mm')}
                </Text>
              </Box>
            </Box>
          </PcDisplayBlock>
          <PcDisplayBlock>
            <Box
              borderLeft={'1px solid'}
              borderColor={'brandSecondary.300'}
              height={'100px'}
              display={'flex'}
              flexDirection={'column'}
              justifyContent={'space-between'}
              pl={5}
            >
              <Box
                style={{
                  overflow: 'hidden',
                  display: '-webkit-box',
                  WebkitBoxOrient: 'vertical',
                  WebkitLineClamp: 2,
                }}
              >
                <Text
                  textStyle={'h5'}
                  fontWeight={'bold'}
                  color={'brandSecondary.500'}
                  as={'h3'} // 部分的なコンテンツ呼び出しを想定してh3にしておく
                >
                  {title}
                </Text>
              </Box>
              <Box
                style={{
                  overflow: 'hidden',
                  display: '-webkit-box',
                  WebkitBoxOrient: 'vertical',
                  WebkitLineClamp: 3,
                }}
                wordBreak={'break-word'}
                textStyle={'h6'}
              >
                {toText(content)}
              </Box>
            </Box>
          </PcDisplayBlock>
        </Flex>
        <SpDisplayBlock
          px={{ base: 3 }}
          display={{ base: 'grid', lg: 'none' }}
        >
          <Box
            style={{
              overflow: 'hidden',
              display: '-webkit-box',
              WebkitBoxOrient: 'vertical',
              WebkitLineClamp: 2,
            }}
          >
            <Text
              textStyle={'h6'}
              fontWeight={'bold'}
              color={'brand.500'}
            >
              {title}
            </Text>
          </Box>
          <Box
            display={'flex'}
            flexDirection={'column'}
            justifyContent={'space-between'}
            mb={2}
          >
            <Box
              style={{
                overflow: 'hidden',
                display: '-webkit-box',
                WebkitBoxOrient: 'vertical',
                WebkitLineClamp: 2,
              }}
              wordBreak={'break-word'}
              textStyle={'h6'}
            >
              {toText(content)}
            </Box>
            <Text
              textStyle={'h6'}
              pt={2}
              fontWeight={'bold'}
              textAlign={'right'}
            >
              {dayjs(publishedStartAt).format('YYYY.MM.DD HH:mm')}
            </Text>
          </Box>
        </SpDisplayBlock>
      </Box>
    </Flex>
  );
};


